<script>
    import { onMount } from "svelte";
    import { panelClose, panelOpen } from "../stores/panelStore";

    import Divider from "./Divider.svelte";
    import Padding from "./Padding.svelte";
    import PanelFooter from "./PanelFooter.svelte";
    import PanelMain from "./PanelMain.svelte";

    export let activity;

    let absolute = false;

    let width;
    let fixedWidth;

    let height;
    let fixedHeight;

    let contracted = false;
    let expanded = false;
    let openId = 0;
    let recentOpen = false;

    panelOpen.subscribe((val) => {
        recentOpen = val == openId;
    });

    function toggleExpandedAndNotify() {
        toggleExpanded();
        if (expanded)
            panelOpen.update((n) => {
                let val = n + 1;
                openId = val;
                return val;
            });
        else panelClose.update((n) => n + 1);
    }

    function toggleExpanded() {
        expanded = !expanded;
        contracted = !expanded;
    }

    panelClose.subscribe((_) => {
        if (expanded) toggleExpanded();
    });

    onMount(async () => {
        fixedHeight = height;
        fixedWidth = width;
        absolute = true;
    });
</script>

<main
    class:expanded
    class:contracted
    class:recent-open={recentOpen}
    bind:clientHeight={height}
    bind:clientWidth={width}
    style="height: {fixedHeight}px; width: {fixedWidth}px;"
>
    <div
        class="panel-layout-color main-panel-container"
        class:absolute
        on:click|stopPropagation={toggleExpandedAndNotify}
    >
        <div class="title-text">{activity.title}</div>
        <Padding vertical="2" />
        <Divider text={activity.dividerText} />
        <div class="subtitle secondary-text-color">
            <div class="body-text">
                {activity.subtitle}
            </div>
            {#if activity.subtitleLink && activity.subtitleLink.icon}
                <Padding horizontal="8" />
                <a on:click|stopPropagation href={activity.subtitleLink.url}>
                    <i
                        class="{activity.subtitleLink
                            .icon} fa-3x secondary-text-color"
                    />
                </a>
            {/if}
        </div>
        <Padding vertical="16" />
        <PanelMain data={activity.main} />
        <Padding vertical="8" />
        <div class="more-info">
            <div class="more-info-text">
                <div>{activity.infoText}</div>
                <Padding vertical="16" />
            </div>
            <div class="more-info-fade" />
        </div>
        <Padding vertical="4" />
        <PanelFooter footerData={activity.footer} />
    </div>
</main>

<style>
    @keyframes bounce-in {
        0% {
            transform: scale(1, 1);
        }
        15% {
            transform: scale(0.75, 0.7);
        }
        40% {
            transform: scale(0.75, 0.7);
        }
        55% {
            transform: scale(1.1, 1.25);
        }
        70% {
            transform: scale(1.1, 1.25);
        }
        90% {
            transform: scale(0.97, 0.95);
        }
        100% {
            transform: scale(1, 1);
        }
    }

    @keyframes bounce-out {
        0% {
            transform: scale(1, 1);
        }
        30% {
            transform: scale(1.05, 1.1);
        }
        45% {
            transform: scale(0.8, 0.65);
        }
        55% {
            transform: scale(0.8, 0.65);
        }
        85% {
            transform: scale(1.01, 1.03);
        }
        100% {
            transform: scale(1, 1);
        }
    }

    main {
        overflow: visible;
        margin: 20px;
        z-index: 1;
    }

    main.recent-open {
        z-index: 2;
    }

    main.expanded {
        z-index: 20;
        animation: bounce-in 0.3s linear forwards;
    }

    main.contracted {
        animation: bounce-out 0.3s linear forwards;
    }

    .absolute {
        position: absolute;
    }

    .main-panel-container .title-text {
        max-width: 80%;
    }

    .main-panel-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        text-align: center;

        cursor: pointer;

        text-align: center;
        border-radius: 25px;
        max-width: 360px;
        min-width: 240px;
        padding: 12px;

        transition: transform 0.1s ease-in-out;
        transition-delay: 0s;
    }

    :not(.expanded) .main-panel-container:hover {
        transform: scale(0.96, 0.96);
    }

    .expanded .main-panel-container {
        transform: translateY(-125px);
        transition-delay: 0.15s;
    }

    .subtitle {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
    }

    .more-info {
        position: relative;
        overflow: hidden;
        width: 100%;
        box-sizing: border-box;
        padding: 0px 32px;
        height: 0px;
        top: 0%;
        transition: height 0.15s ease-out;
        transition-delay: 0s;
    }

    .expanded .more-info {
        height: 250px;
        transition-delay: 0.13s;
    }

    .more-info-text {
        height: 100%;
        overflow-y: auto;
    }

    .more-info-fade {
        position: absolute;
        width: 100%;
        bottom: 0px;
        height: 20px;
        background: linear-gradient(to top, #fffbf5ff 0%, #fffbf500 100%);
    }

    a {
        font-size: 0.5em;
    }

    a:hover {
        animation: bounce 0.4s ease-out forwards;
    }
</style>
